var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntegrations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_625_7620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 13.9999V19.9999C13 20.5499 13.45 20.9999 14 20.9999H20C20.55 20.9999 21 20.5499 21 19.9999V13.9999C21 13.4499 20.55 12.9999 20 12.9999H14C13.45 12.9999 13 13.4499 13 13.9999ZM4 20.9999H10C10.55 20.9999 11 20.5499 11 19.9999V13.9999C11 13.4499 10.55 12.9999 10 12.9999H4C3.45 12.9999 3 13.4499 3 13.9999V19.9999C3 20.5499 3.45 20.9999 4 20.9999ZM3 3.99992V9.99992C3 10.5499 3.45 10.9999 4 10.9999H10C10.55 10.9999 11 10.5499 11 9.99992V3.99992C11 3.44992 10.55 2.99992 10 2.99992H4C3.45 2.99992 3 3.44992 3 3.99992ZM15.95 2.39992L11.7 6.63992C11.31 7.02992 11.31 7.65992 11.7 8.04992L15.95 12.2999C16.34 12.6899 16.97 12.6899 17.36 12.2999L21.61 8.04992C22 7.65992 22 7.02992 21.61 6.63992L17.37 2.39992C16.98 2.00992 16.34 2.00992 15.95 2.39992V2.39992Z",
    fill: "#191C43"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_625_7620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrations);
export default __webpack_public_path__ + "static/media/Integrations.0948e3a589cbc084188d9fcf50d4f283.svg";
export { ForwardRef as ReactComponent };